import { useCallback, useContext, useEffect, useState } from 'react';
import FetchContext from '../fetch-context';

export function useGraphQLQuery<T>(options: {
  query: string;
  variables: Record<string, unknown>;
  refreshOnMount?: boolean;
}): { loading: boolean; data: T | null; refresh: () => Promise<void> } {
  const { query, variables, refreshOnMount } = options;
  const fetchContext = useContext(FetchContext);

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<T | null>(null);

  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      const response = await fetchContext.query(query, variables);

      setData(response.data);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, [fetchContext, query, variables]);

  useEffect(() => {
    if (refreshOnMount) {
      refresh();
    }
  }, []);

  return { loading, data, refresh };
}
